/* global BOOMR, window, $ */
/*eslint-disable no-undef*/

'use strict';

// code spliting
require('./loaders/facebook');

__webpack_public_path__ = assetsUrl;

$(window).load(() => {
  const modulePromises = [];
  if (
    window.payload.loadSwitch &&
    window.payload.loadSwitch.shouldLoadDealWidgets
  ) {
    modulePromises.push(
      import(/* webpackChunkName: "widgets" */ './loaders/widgets')
    );
  }
  if (
    window.payload.loadSwitch &&
    window.payload.loadSwitch.shouldShowTipWidget
  ) {
    modulePromises.push(
      import(/* webpackChunkName: "tip_widget" */ './loaders/tip_widget')
    );
  }
  if (window.payload.merchantV2) {
    modulePromises.push(
      import(/* webpackChunkName: "merchant_v2" */ './loaders/merchant_v2')
    );
  } else {
    modulePromises.push(
      import(/* webpackChunkName: "g_map" */ './loaders/g_map')
    );
  }

  window.asyncInitializer(modulePromises, 40 * 1000, initStart => {
    if (typeof BOOMR !== 'undefined' && typeof BOOMR.addVar === 'function') {
      BOOMR.addVar('deal_page_async_modules_loaded', new Date() - initStart);
    }
  });
});



// WEBPACK FOOTER //
// ./core/frontend/webpack/async_scripts/local.js